<template>
    <div class="app-container">
        <div class="anjian-wrap">
            <!-- 搜索 -->
            <div class="common-section-bg anjian-shaixuan">
                <div class="shaixuan-item">
                    <el-select v-model="listQuery.community_id" clearable filterable placeholder="请选择小区">
                        <el-option v-for="item in optionList" :key="item.id" :label="item.name" :value="item.id" />
                    </el-select>
                </div>
                <div class="shaixuan-item">
                    <el-date-picker v-model="listQuery.begin_at" type="date" placeholder="开始时间"
                        value-format="yyyy-MM-dd">
                    </el-date-picker>
                </div>
                <div class="shaixuan-item">
                    <el-date-picker v-model="listQuery.end_at" type="date" placeholder="结束时间" value-format="yyyy-MM-dd">
                    </el-date-picker>
                </div>
                <div class="shaixuan-item">
                    <el-button type="primary" @click="handleFilter" icon="el-icon-search">
                        {{ $t("table.search") }}
                    </el-button>
                </div>
                <div class="shaixuan-item">
                    <el-button type="primary" @click="exportData" icon="el-icon-document-checked">
                        导出
                    </el-button>
                </div>
            </div>
            <div class="common-section-bg common-section-top biaoge-data">
                <el-table v-loading="listLoading" :data="tableData" style="width: 100%">
                    <el-table-column prop="id" label="id" width="80" />
                    <el-table-column prop="community_name" label="小区名称" align="center" min-width="200" />
                    <el-table-column prop="resourcename" label="资源名称" align="center" min-width="200" />
                    <el-table-column prop="phone" label="用户" align="center" min-width="200" />
                    <el-table-column prop="score" label="得分" align="center" min-width="100" />
                    <el-table-column prop="created_at" label="填写时间" align="center" min-width="200" />
                    <el-table-column label="操作" align="center" width="120" fixed="right">
                        <template slot-scope="scope">
                            <el-button @click="showEdit(scope.row.id)" type="success">
                                查看
                            </el-button>
                        </template>
                    </el-table-column>

                </el-table>
                <!-- 分页 -->
                <pagination v-show="total" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.size"
                    @pagination="getList" />
            </div>
            <!-- 查看 -->
            <el-drawer custom-class="custom-drawer" :visible.sync="showDrawer" :close-on-press-escape="false"
                :wrapper-closable="false" :show-close="false" size="1000px">
                <template slot="title">
                    <div class="custom-title">
                        <div class="title-name">详情</div>
                        <i class="el-icon-circle-close close-btn pointer" @click="closeDrawerFun" />
                    </div>
                </template>
                <div class="custom-content">
                    <el-form ref="ruleForm" :model="guanliInfo" :rules="rules" label-width="130px">
                        <el-form-item label="小区名称" prop="name">
                            <span>{{ guanliInfo.community_name || '' }}</span>
                        </el-form-item>
                        <el-form-item label="资源编号" prop="name">
                            <span>{{ guanliInfo.resource || '' }}</span>
                        </el-form-item>
                        <el-form-item label="用户" prop="name">
                            <span>{{ guanliInfo.phone || '' }}</span>
                        </el-form-item>
                        <el-form-item label="得分" prop="name">
                            <span>{{ guanliInfo.score || 0 }}</span>
                        </el-form-item>
                        <el-form-item label="问卷" prop="name">
                            <div class="wenjuan-list">
                                <div class="wenjuan-box" v-for="(item, index) in guanliInfo.ti_detail" :key="index">
                                    <!-- 单选 -->
                                    <div class="wenjuan-item" v-if="item.type == 1">
                                        <div class="title">{{ index + 1 }}、{{ item.name }}</div>
                                        <div class="item-xuan">
                                            <el-radio-group v-model="item.selected_option">
                                                <el-radio :label="xuan.id" v-for="(xuan, int) in item.option"
                                                    :key="int">{{ xuan.name
                        || '' }}</el-radio>
                                            </el-radio-group>
                                        </div>
                                    </div>
                                    <!-- 多选 -->
                                    <div class="wenjuan-item" v-if="item.type == 2">
                                        <div class="title">{{ index + 1 }}、{{ item.name }}</div>
                                        <div class="item-xuan">
                                            <el-checkbox-group v-model="item.selected_options">
                                                <el-checkbox :label="xuan.id" v-for="(xuan, int) in item.option"
                                                    :key="int">{{ xuan.name || '' }}</el-checkbox>
                                            </el-checkbox-group>
                                        </div>
                                    </div>
                                    <!-- 填空 -->
                                    <div class="wenjuan-item" v-if="item.type == 3">
                                        <div class="title">{{ index + 1 }}、{{ item.name }}</div>
                                        <div class="item-xuan">答：{{ item.content }}</div>
                                    </div>
                                </div>
                            </div>
                        </el-form-item>
                    </el-form>
                </div>
            </el-drawer>
        </div>
    </div>
</template>

<script>
import guanli from "@/api/tianzheng/guanli";
import Pagination from '@/components/Pagination';
export default {
    components: {
        Pagination
    },
    data() {
        return {
            // 列表搜索参数
            listQuery: {
                survey_id: "",
                community_id: "",
                begin_at: "",
                end_at: "",
                page: 1,
                size: 10
            },
            total: 0,//总条数
            tableData: [],//表格记录数据
            listLoading: false,//表格加载
            optionList: [],//当前小区下拉数据
            showDrawer: false,//新增编辑弹出
            guanliInfo: {},//问卷管理详情
            rules: {}
        }
    },
    created() {
        this.listQuery.survey_id = this.$route.query.id;//问卷id
        this.getSelectCity();//小区下拉
        this.getList();//表格数据
    },
    methods: {
      exportData(){
        let that = this
        guanli.exportData(this.listQuery).then((res) => {
          if (res.code == 200) {
            if(res.result) {
              window.open(res.result)
            }
          } else {
            this.$message.error(res.message);
          }
        }).catch(err => {
          that.$message.error(err);
          console.log("报错信息", err);
        })
      },
        // 点击查看
        showEdit(id) {
            let that = this;
            that.showDrawer = true;
            that.resetForm();
            guanli.detail({ id: id }).then(res => {
                if (res.code == 200) {
                    that.guanliInfo = res.result;
                }
            })
        },
        // 点击搜索
        handleFilter() {
            this.listQuery.page = 1;
            this.getList();
        },
        // 表格数据
        getList(val) {
            if (val && val.page) {
                this.listQuery.page = val.page
            }
            this.listLoading = true
            guanli.list(this.listQuery).then(res => {
                this.listLoading = false
                if (res.code == 200) {
                    this.tableData = res.result.list
                    this.total = res.result.total
                }
            })
        },
        // 获取小区下拉列表
        getSelectCity() {
            guanli.communitySelect({ survey_id: this.listQuery.survey_id }).then(res => {
                if (res.code == 200) {
                    this.optionList = res.result;
                }
            })
        },
        /**
      * @name: 清空
      * @return {*}
      * @desc:
      */
        resetForm() {
            this.guanliInfo = {};
            if (this.$refs["ruleForm"]) {
                this.$refs["ruleForm"].resetFields();
            }
        },
        /**
         * @name: 关闭弹层
         * @return {*}
         * @desc:
         */
        closeDrawerFun() {
            this.showDrawer = false
            this.resetForm()
        },
    },
}
</script>

<style scoped>
.el-radio {
    pointer-events: none;
}

.el-checkbox {
    pointer-events: none;
}
</style>
